import analytics from './js/analytics'
// import whatsapp from './js/whatsapp'
// import canva from './js/canva'
import body from './js/body'
import inviewport from './js/inviewport'
import './js/typewriter'
import trikavideosinspiration from './js/trikavideosinspiration'

(function ($) {

  analytics($) 
  body($)
  inviewport($)
  trikavideosinspiration($)
  // canva($)
  // whatsapp($)

})(jQuery);